<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
/*全局样式*/
*{padding:0;margin:0;}
div,dl,dt,dd,form,h1,h2,h3,h4,h5,h6,img,ol,ul,li,table,th,td,p,span,a{border:0px solid red;}
img,input{border:none; vertical-align:middle; outline:medium;}
body{font-family:"Helvetica Neue",HelveticaNeue,Helvetica,Arial,sans-serif; font-size:16px; text-align:center; background:#fff;}
html{overflow-y:auto;}
ul li{list-style-type:none;}
a{text-decoration:none; color:#333;}
a:hover{text-decoration:none; color: #1BB1FE;}
textarea{resize:none;}

.item-font{font-family:"Helvetica Neue",HelveticaNeue,Helvetica,Arial,sans-serif;}
.float-left{float:left;}
.float-right{float:right;}
.clear:after{content: ' '; clear: both; display: block;}
.pointer{cursor: pointer;}
.red-font{color: #E02B20;}
.blue-font{color: #00BFFF;}
.gray-font{color: #333333;}
.yellow-font{color: #E6A23C;}
.green-font{color: green;}

.font-22{font-size: 22px;}
.font-20{font-size: 20px;}
.font-18{font-size: 18px;}
.font-16{font-size: 16px;}
.font-13{font-size: 13px;}
.font-12{font-size: 12px;}
.font-10{font-size: 10px;}
.font-weight{font-weight: bold;}

.line-1{
	overflow:hidden; 
	text-overflow:ellipsis;	
	display:-webkit-box; 	
	/* autoprefixer: off */  
  -webkit-box-orient: vertical;  
  /* autoprefixer: on */
 -webkit-line-clamp:1;	
}
.line-2{
	overflow:hidden; 
	text-overflow:ellipsis;	
	display:-webkit-box; 	
	/* autoprefixer: off */  
  -webkit-box-orient: vertical;  
  /* autoprefixer: on */	
	-webkit-line-clamp:2; 
}
.line-3{
	overflow:hidden; 
	text-overflow:ellipsis;	
	display:-webkit-box; 	
	/* autoprefixer: off */  
  -webkit-box-orient: vertical;  
  /* autoprefixer: on */	
	-webkit-line-clamp:3; 
}

.el-table .cell{
	word-break: normal!important; 
	overflow:hidden; 
	text-align: center;
}
.el-popover__title{
	background-color: #E4E4E4;
    padding: 5px;
}

/*所有页面表头表单通用样式*/
.table-head{
	 > ul{
		margin: 10px 0;
	}
	ul li{
		float: left; margin-right: 10px;
	}
}
.search-but button{
	margin-bottom: 10px;
}

.tb-edit .el-input {
    display: none
}
.tb-edit .current-row .el-input {
    display: block
}
.tb-edit .current-row .el-input+span {
    display: none
}

.balanceOnHand .el-table {
	th>.cell{
		white-space: pre-wrap;
	}
	thead th{
		padding: 5px 0;
	}
}
.el-table .cell{
	word-break: normal; 
	overflow:hidden; 
	text-align: center;
}
.el-popover__title{
	background-color: #E4E4E4;
  padding: 5px;
}
/*页面导航、搜索等通用样式*/
.nav-list{
	border-bottom: 1px solid #E4E4E4; text-align: left; padding-bottom: 3px;
	span:first-child{
		margin-right: 5px;
	}
	span:last-child{
		margin-left: 5px;
	}	
}
.nav-head, .nav-head-one{
	border-bottom: 1px solid #E4E4E4; margin-top: 10px; padding-left: 10px;
}
/*单菜单样式*/
.nav-head-one ul li{
	float: left; 
	padding: 10px 15px; 
	border-top: 5px solid #E02B20; 
	border-left: 1px solid #BCBCBC; 
	border-right: 1px solid #BCBCBC; 
	border-bottom: 1px solid #fff;
    position: relative;
    top: 1px;
	cursor: pointer;
}
/*多菜单样式*/
.nav-head ul{
	li{
		float: left; 
		padding: 10px 15px; 
		margin-right: 10px;
		border-top: 1px solid #BCBCBC; 
		border-left: 1px solid #BCBCBC; 
		border-right: 1px solid #BCBCBC; 
	  position: relative;
	  top: 5px;
		cursor: pointer;
	}
	li.active{
		border-top: 5px solid #E02B20; 
		border-bottom: 1px solid #fff;
		color: #E02B20;
		font-weight: bold;
	    position: relative;
	    top: 1px;
	}
}

.search-but{
	text-align: right; /*padding-right: 15%;*/
}
.demo-input-suffix{
	> span{	
		display: inline-block; width: 100px; text-align: right; padding-right: 10px; float: left;
	}
	> span.oneline{
		height: 40px; line-height: 40px;
	}
}
.table-head ul li{
	margin-bottom: 10px;
}
.table-body{
	/*max-width: 1600px;*/
}

.table-top-set{
	background-color: #F5F7FA; padding: 5px;
}
.table-column-set{
	width: 180px; background-color: #fff; border: 1px solid #C9C9C9; cursor: pointer;
}
.check-column li{
	border-bottom: 1px solid #D7D7D7;
}
.day-of-week{
	display: inline-block; margin: 10px 0 10px 20px;
	li{
		border: 1px solid #BCBCBC; padding: 2px 10px;
	}
	li:hover{
		background-color: #E02B20; color: #fff; border: 1px solid #E02B20;
	}
	li.active{
		background-color: #E02B20; color: #fff; border: 1px solid #E02B20;
	}
}
/*页面导航、搜索等通用样式end*/

/*数字类型input去掉加减按钮显示*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}
.operating:hover{ /*页面编辑hover样式*/
	color: #9093A6;
}
/*页面textarea的placeholder样式*/
textarea,textarea::-webkit-input-placeholder, input::-webkit-input-placeholder {
  font-family:微软雅黑; color: #C0C4CC;
}
textarea,textarea:-moz-placeholder, input:-moz-placeholder{/* Firefox 18- */
  font-family:微软雅黑; color: #C0C4CC;
}
textarea,textarea::-moz-placeholder, input::-moz-placeholder{/* Firefox 19+ */
 font-family:微软雅黑; color: #C0C4CC;
}
textarea,textarea:-ms-input-placeholder, input:-ms-input-placeholder{
  font-family:微软雅黑; color: #C0C4CC;
}
/*页面弹窗样式*/
.el-dialog__header{
	text-align: left;
}
.dislog .el-form-item__content{
	text-align: left;	
}	
.edit-input{
	padding: 0 5px;
}
/*打印头信息样式*/
.pointer-title{
	padding: 10px;
	p{
		color:#8C939D; text-align: right;  padding-right: 0px;
	}
	.title-left{
		float: left;
	}	
	.title-right{
		float: right;
		.title-date{
			margin-left: 20px;
		}
	}	
}
.stepThreeDialog .el-dialog__body {
	height: 500px;
	overflow: auto;
}

.scheduleCheck .el-checkbox-button .el-checkbox-button__inner {
	margin: 0 10px;
	border-radius: 4px!important;
	border: 1px solid #DCDFE6;
}
.scheduleCheck .el-checkbox-button.is-checked .el-checkbox-button__inner {
	background-color: #E02B20;
	border-color: #E02B20;
	box-shadow: -1px 0 0 0 #e02b20;
}
.scheduleCheck .el-checkbox-button__inner:hover {
	color: #E02B20;
}
.scheduleCheck .el-checkbox-button.is-focus .el-checkbox-button__inner {
	border-color: #E02B20;
}
.scheduleDailog .el-dialog__footer {
	text-align: center;
}

.inventoryDialog .el-radio-button.is-active .el-radio-button__inner {
	background-color: #E02B20;
	border-color: #E02B20;
	box-shadow: -1px 0 0 0 #e02b20;
}
.inventoryDialog .el-radio-button__inner:hover {
	color: #E02B20;
}
.inventoryDialog .el-radio-button .el-radio-button__inner {
	margin: 0 10px;
	border-radius: 4px!important;
	border: 1px solid #DCDFE6;
}

.inventoryDialog .el-dialog__body{
	height: 300px;
	overflow: auto;
}
.inventoryDialog .el-dialog__footer {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// App.vue?16dd96b3